import { AlertCircle, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface ErrorBannerProps {
  details?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorBanner({ message, details, onRetry }: ErrorBannerProps) {
  return (
    <Alert variant="destructive">
      <AlertCircle className="size-4" />
      <AlertTitle className="flex items-center justify-between">
        <span>{message}</span>
        {onRetry && (
          <Button className="ml-2 shrink-0 gap-1" onClick={onRetry} size="sm" variant="outline">
            <RefreshCw className="size-3" />
            Retry
          </Button>
        )}
      </AlertTitle>
      {details && <AlertDescription>{details}</AlertDescription>}
    </Alert>
  );
}
